export function getCurrentLang() {
    let userLang = navigator.language || navigator.userLanguage;

    return userLang === 'de' ? 'de' : 'en';
}

export function getCurrentTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
}